import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './stores/authStore'

// Auth components
import Login from './pages/auth/Login'
import ForgotPassword from './pages/auth/ForgotPassword'
import ResetPassword from './pages/auth/ResetPassword'
import ProtectedRoute from './components/auth/ProtectedRoute'

// Layout
import AppLayout from './components/layout/AppLayout'

// Pages
import Dashboard from './pages/dashboard/Dashboard'
import ContractsOverview from './pages/contracts/ContractsOverview'
import ContractCreate from './pages/contracts/ContractCreate'
import ContractDetail from './pages/contracts/ContractDetail'
import TrainersOverview from './pages/trainers/TrainersOverview'
import TrainerCreate from './pages/trainers/TrainerCreate'
import TrainerDetail from './pages/trainers/TrainerDetail'
import TrainerEdit from './pages/trainers/TrainerEdit'
import TeamsOverview from './pages/teams/TeamsOverview'
import TeamCreate from './pages/teams/TeamCreate'
import TeamDetail from './pages/teams/TeamDetail'
import ActivityLogs from './pages/activity/ActivityLogs'
import EmailHistory from './pages/emails/EmailHistory'
import PaymentsOverview from './pages/payments/PaymentsOverview'
import Settings from './pages/settings/Settings'
import TemplateManagement from './pages/templates/TemplateManagement'
import TemplateEditor from './pages/templates/TemplateEditor'
import SignatureZoneEditor from './pages/templates/SignatureZoneEditor'
import ContractBuilder from './pages/contracts/ContractBuilder'

// Public Pages
import SignContract from './pages/public/SignContract'

function App() {
  const { isAuthenticated } = useAuthStore()

  return (
    <Router>
      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/sign/:token" element={<SignContract />} />
        
        {/* Protected Routes with Layout */}
        <Route
          element={
            <ProtectedRoute>
              <AppLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/dashboard" element={<Dashboard />} />
          
          {/* Contracts */}
          <Route path="/contracts" element={<ContractsOverview />} />
          <Route path="/contracts/new" element={<ContractCreate />} />
          <Route path="/contracts/builder" element={<ContractBuilder />} />
          <Route path="/contracts/:id" element={<ContractDetail />} />
          
          {/* Templates */}
          <Route path="/templates" element={<TemplateManagement />} />
          <Route path="/templates/new" element={<TemplateEditor />} />
          <Route path="/templates/:id/edit" element={<TemplateEditor />} />
          <Route path="/templates/:id/signature-zones" element={<SignatureZoneEditor />} />
          
          {/* Trainers */}
          <Route path="/trainers" element={<TrainersOverview />} />
          <Route path="/trainers/new" element={<TrainerCreate />} />
          <Route path="/trainers/:id/edit" element={<TrainerEdit />} />
          <Route path="/trainers/:id" element={<TrainerDetail />} />
          
          {/* Teams */}
          <Route path="/teams" element={<TeamsOverview />} />
          <Route path="/teams/new" element={<TeamCreate />} />
          <Route path="/teams/:id" element={<TeamDetail />} />
          
          {/* Payments */}
          <Route path="/payments" element={<PaymentsOverview />} />
          
          {/* Activity Logs */}
          <Route path="/activity" element={<ActivityLogs />} />
          
          {/* Email History */}
          <Route path="/emails" element={<EmailHistory />} />
          
          {/* Settings (admin only) */}
          <Route path="/settings" element={<Settings />} />
        </Route>
        
        {/* Root redirect */}
        <Route
          path="/"
          element={
            isAuthenticated() ? (
              <Navigate to="/dashboard" replace />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />
        
        {/* 404 - Catch all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  )
}

export default App